/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import {withRouter} from 'react-router';

import {Nav, NavItem, Glyphicon, Grid, Row, Col, Well} from 'react-bootstrap';
import ManageUserView from './admin/user/manageUsersView';
import ManageDealersView from './admin/dealers/manageDealersView';


class UserDealerSelectView extends React.Component {
    constructor(props) {
        console.log("[UserDealerSelect] - initialisation");
        super(props);

        this.handleTypeSelect = this.handleTypeSelect.bind(this);

        this.state = {
            activeTab : "1",
            jobNames: null,
            addingUser : false,
            loading : true,
            users : []
        };
    }

    handleTypeSelect(eventKey) {
        this.setState({activeTab: eventKey});
    }


    render() {
        let tab = this.state.activeTab;

        return (
            <div>
                <Grid>
                    <Row>
                        <Well className="dealerHeader">
                            <h1>Dealer and User Management</h1>
                        </Well>
                    </Row>
                    <Row>
                        <Col>
                            <Nav  bsStyle="pills"  activeKey={this.state.activeTab} onSelect={this.handleTypeSelect.bind(this)}>
                                <NavItem eventKey="1" active={this.state.activeTab==="1"} >Dealers</NavItem>
                                <NavItem eventKey="2" active={this.state.activeTab==="2"} ><Glyphicon glyph="user"/>{' '}Users</NavItem>
                            </Nav>
                        </Col>
                    </Row>
                    <Row ><Col><br /></Col></Row>
                    {(tab === "1") &&
                        <div>
                            <ManageDealersView />
                        </div>
                    }
                    {(tab === "2") &&
                        <div>
                            <ManageUserView />
                        </div>
                    }

                </Grid>
            </div>
        );
    }
}

export default withRouter(UserDealerSelectView);



// WEBPACK FOOTER //
// ./src/app/components/userDealerSelect.js